<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Perfis de Acesso</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div class="two wide field">
                  <label for="profile-search-cod">Código</label>
                  <input type="text" name="profile-search-cod" v-model="searchForm.cod">
                </div>
                <div class="six wide field">
                  <label for="profile-search-description">Descrição</label>
                  <input type="text" name="profile-search-description" v-model="searchForm.description">
                </div>
                <div class="end field">
                  <input type="submit" name="commit" value="Filtrar" class="ui button">
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              :columns="gridColumns"
              resource="profiles"
              @refresh="search()"
              @page="n => search(n)" />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
  import Api from '@/resources/Api'
  import Breadcrumb from '@/components/breadcrumb'
  import PageLayout from '@/layouts/page_layout'
  import Grid from '@/components/grid'

  export default {
    name: 'profiles',
    components: { Grid, Breadcrumb, PageLayout },

    data () {
      return {
        searchForm: {
          description: null,
          cod: null
        },
        query: {},
        gridColumns: [
          {description: null, kind: 'status', field: 'enable'},
          {description: null, kind: 'edit', field: 'id'},
          {description: 'Cod', field: 'id'},
          {description: "Perfil de Acesso", field: 'description'},
        ]
      }
    },

    mounted () {
      this.search()
    },

    methods: {
      search (page = 1) {
        const query = {
          "q": {
            "description_cont": this.searchForm.description,
            "id_eq": this.searchForm.cod,
          },
          page: page
        };

        this.$refs.grid.toggleLoading();
        Api.profiles.search(query).then(async (response) => {
          this.$refs.grid.setItems(response.data.profiles)
          this.$refs.grid.setPaginate(response.data.pagination)
        }).catch((error) => {
          this.$toast.show("Erro ao carregar", "error");
          throw error;
        }).finally(() => {
          this.$refs.grid.toggleLoading();
        });
      }
    }
  }
</script>
